export var SceneDefines;
(function (SceneDefines) {
    SceneDefines[SceneDefines["NONE"] = 0] = "NONE";
    SceneDefines[SceneDefines["LOGIN"] = 1] = "LOGIN";
    SceneDefines[SceneDefines["HOME_SCENE"] = 2] = "HOME_SCENE";
})(SceneDefines || (SceneDefines = {}));
//# sourceMappingURL=SceneDefines.js.map